import { Dialog } from '@mui/material'
import { useContext, useEffect, useState } from 'react'
import { Spinner } from 'react-bootstrap'
import { Link, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { FAQ_CATEGORIES } from 'src/consumer/constants'
import { ProfileContext } from 'src/consumer/context/ProfileContext'
import { SEOComponent } from 'src/consumer/helpers/utilFunctions'
import { logoutHandler } from 'src/consumer/services/loginLogoutHandlers'
import { getData } from 'src/consumer/services/profileService'
import { getImageLink } from 'src/mentor/helpers/utilityFunctions'
import { isTokenInvalidOrAbsent } from 'src/views/pages/login/ProtectedRoute'
import { PublicAppFooter } from '../PublicAppFooter'
import PublicAppHeader from '../PublicAppHeader'
import { AppFAQModalComponent } from '../ServiceProvidersListingPage/ServiceProvidersListingComponents'
import { ClubbedAuthModal } from '../SignIn/ClubbedAuthComponents'
import { CustomInput } from '../helperComponents'
import {
  AvatarGenericLetterComponent,
  MDAADeleteButton,
  MDAAFaqBox,
  MDAAFaqBoxesContainer,
  MDAAHeading,
  MDAAParentContainer,
} from './ManageDataAndAccountStyles'
import { LocalizationContext } from 'src/consumer/context/LocalizationContext'
import LaunchIcon from '@mui/icons-material/Launch'

export default function ManageDataAndAccount() {
  const { profileData } = useContext(ProfileContext)
  const [showClubbedAuthModal, setShowClubbedAuthModal] = useState(false)
  const [typeOfClubbedAuthModal, setTypeOfClubbedAuthModal] = useState('login')
  const { localizedDataLoading, localizedData, localizedDataError } =
    useContext(LocalizationContext)

  const strings = localizedData?.strings?.manageDataAndAccountPage

  const [deleteAccountDialogOpen, setDeleteAccountDialogOpen] = useState(false)
  const [userEnteredText, setUserEnteredText] = useState('')
  const [deleteAllowString, setDeleteAllowString] = useState('')
  const [waitingDeleteAPI, setWaitingDeleteAPI] = useState(false)
  const [requestSuccess, setRequestSuccess] = useState(false)

  const [selectedFaqCategory, setSelectedFaqCategory] = useState()
  const [faqOpen, setFaqOpen] = useState(false)

  const navigate = useNavigate()

  async function deleteAccountFunction() {
    setRequestSuccess(false)
    setWaitingDeleteAPI(true)
    const response = await getData('/api/secure/user/delete')
    setWaitingDeleteAPI(false)
    if (response?.status === 200) {
      setRequestSuccess(true)
    } else {
      toast.error('Could not delete account')
    }
  }

  useEffect(() => {
    let slugFromName = 'me'
    if (profileData?.name) {
      const array = profileData?.name?.split(' ')
      let newString = array.join('-')?.toLowerCase()
      slugFromName = newString
    }
    setDeleteAllowString(`delete-account-for-${slugFromName}`)
  }, [profileData])

  const userLoggedIn = !Boolean(isTokenInvalidOrAbsent(localStorage.getItem('token')))

  const loggedInCategories = [
    {
      id: 'steps_to_manage_data_faqs',
      text: strings?.manage_your_data_faqs || 'Understand steps to manage your data',
    },
    {
      id: 'understand_how_we_use_your_data_faqs',
      text: strings?.how_we_use_data_faqs || 'Understand how we use your data',
    },
  ]
  const notLoggedInCategories = [
    {
      id: 'steps_to_manage_data_faqs',
      text: strings?.manage_your_data_faqs || 'Understand steps to manage your data',
    },
  ]

  return (
    <>
      <SEOComponent
        title={strings?.data_and_account || 'Data and Account'}
        description={strings?.description_of_page || `Understand how AUMHUM manages your data.`}
      />
      <PublicAppHeader
        config={{ showLinks: true }}
        loginFunction={() => {
          setTypeOfClubbedAuthModal('login')
          setShowClubbedAuthModal(true)
        }}
        registerFunction={() => {
          setTypeOfClubbedAuthModal('signup')
          setShowClubbedAuthModal(true)
        }}
      />

      <MDAAParentContainer>
        {/* headings */}
        <div>
          {userLoggedIn && (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              {profileData?.profilePicId ? (
                <img
                  src={getImageLink(profileData?.profilePicId)}
                  alt="user"
                  style={{ height: '75px', width: '75px', borderRadius: '50%' }}
                />
              ) : (
                <AvatarGenericLetterComponent name={profileData?.name} />
              )}
            </div>
          )}
          {userLoggedIn ? (
            <MDAAHeading>
              {strings?.welcome_user
                ? strings?.welcome_user?.replace('{1}', profileData?.name)
                : `Welcome ${profileData?.name}`}
            </MDAAHeading>
          ) : (
            <MDAAHeading>{strings?.data_and_account || 'Data and Account'}</MDAAHeading>
          )}
          <MDAAHeading desc>
            {strings?.description_of_page ||
              `Discover our commitment to your privacy and data
            security. Learn about the privacy options available to you, and control the information
            saved.`}
          </MDAAHeading>
        </div>

        {/* FAQs */}
        <MDAAFaqBoxesContainer>
          {userLoggedIn
            ? loggedInCategories?.map((item, index) => (
                <MDAAFaqBox
                  key={index}
                  onClick={() => {
                    setSelectedFaqCategory(item?.id)
                    setFaqOpen(true)
                  }}
                >
                  {item?.text}
                </MDAAFaqBox>
              ))
            : notLoggedInCategories?.map((item, index) => (
                <MDAAFaqBox
                  key={index}
                  onClick={() => {
                    setSelectedFaqCategory(item?.id)
                    setFaqOpen(true)
                  }}
                >
                  {item?.text}
                </MDAAFaqBox>
              ))}
        </MDAAFaqBoxesContainer>

        {/* Actions */}
        {userLoggedIn ? (
          <div
            style={{
              position: 'absolute',
              bottom: '20px',
              left: 0,
              right: 0,
              textAlign: 'center',
              cursor: 'pointer',
              marginTop: '100px',
            }}
            onClick={() => {
              setDeleteAccountDialogOpen(true)
            }}
          >
            <u>{strings?.delete_account || 'Delete my Account'}</u>
          </div>
        ) : (
          <div
            style={{
              position: 'absolute',
              bottom: '20px',
              left: 0,
              right: 0,
              fontWeight: '500',
              textAlign: 'center',
              cursor: 'pointer',
              padding: '4px 8px',
              color: '#fff',
              background: '#514387',
              width: '140px',
              borderRadius: '4px',
              margin: '0 auto',
            }}
            onClick={() => {
              setTypeOfClubbedAuthModal('login')
              setShowClubbedAuthModal(true)
            }}
          >
            {strings?.login_to_start || 'Login to Start'}
          </div>
        )}
      </MDAAParentContainer>

      <ClubbedAuthModal
        open={showClubbedAuthModal}
        onClose={() => setShowClubbedAuthModal(false)}
        loginVariant={typeOfClubbedAuthModal === 'login'}
      />
      <AppFAQModalComponent
        categories={[FAQ_CATEGORIES[selectedFaqCategory]]}
        open={faqOpen}
        onClose={() => setFaqOpen(false)}
      />
      <Dialog
        open={deleteAccountDialogOpen}
        onClose={() => setDeleteAccountDialogOpen(false)}
        PaperProps={{
          sx: { padding: '20px' },
        }}
      >
        {requestSuccess ? (
          <>
            <div>
              <b>Your account deletion request has been submitted successfully.</b>
            </div>
            <div>Your account data will be deleted within 30 days.</div>
            <div
              style={{
                textDecoration: 'underline',
                marginTop: '20px',
                textAlign: 'center',
                cursor: 'pointer',
              }}
              onClick={() => {
                logoutHandler()
                navigate('/')
              }}
            >
              I understand
            </div>
          </>
        ) : (
          <>
            <div>
              <b>
                {strings?.delete_account_headline ||
                  'Are you sure you want to delete your AUMHUM account?'}
              </b>
            </div>
            <div>
              {strings?.instead_take_help ||
                'Instead, if you need any help accessing your account, click here'}
              <Link to="/help-center">
                <LaunchIcon />
              </Link>
            </div>
            <div style={{ marginTop: '20px' }}>
              {strings?.delete_warning ||
                'By proceeding, you will lose access to all your purchased subscriptions, content, and booked sessions with mentors.'}
            </div>
            <div style={{ marginTop: '20px' }}>
              {strings?.type_to_process
                ? strings?.type_to_process?.replace('{1}', deleteAllowString)
                : `Type ${deleteAllowString} to proceed:`}
            </div>
            <CustomInput
              value={userEnteredText}
              onChange={(e) => setUserEnteredText(e.target.value)}
            />
            <MDAADeleteButton
              style={{ marginTop: '10px' }}
              disabled={userEnteredText !== deleteAllowString || waitingDeleteAPI}
              onClick={deleteAccountFunction}
            >
              {waitingDeleteAPI ? (
                <Spinner animation="border" variant="light" size="sm" />
              ) : (
                `${strings?.delete || 'Delete'}`
              )}
            </MDAADeleteButton>
          </>
        )}
      </Dialog>
      <PublicAppFooter />
    </>
  )
}
